import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { CommonIcons } from 'common-src/assets/Icons';
import { Button } from 'common-src/components/base';
import { ColorsNew } from 'common-src/styles';

import styles from './Accordion.module.scss';

const Accordion = ({
  title,
  instructions,
  content,
  classNames = [],
  isDefaultExpanded = false,
  onNavigateClick,
}) => {
  const [isExtended, setIsExtended] = useState(isDefaultExpanded);

  return (
    <div className={[styles.container, ...classNames, 'primary-border'].join(' ')}>
      <div
        className={[
          'flex-row',
          'vertically-centered',
          'gap-16',
          'cursor-pointer',
          'p-16',
          'disable-select',
          instructions ? 'p-b-5' : '',
        ].join(' ')}
        onClick={() => setIsExtended((prev) => !prev)}
        role="presentation"
      >
        <img
          src={CommonIcons.arrowDownIcon}
          alt="arrow-down-icon"
          className={[styles.arrow, isExtended ? styles.rotate : ''].join(' ')}
        />
        <p
          id={`accordion-title-${title.toLowerCase()}`}
          className={['font-w-600', 'font-s-16'].join(' ')}
        >
          {title}
        </p>
      </div>
      {instructions && (
        <p className={[styles.instructions, 'font-s-12', 'm-l-16', 'm-r-16', 'm-b-16'].join(' ')}>
          {instructions}
        </p>
      )}
      {isExtended && (
        <div className={styles.content}>
          {content}
          {onNavigateClick && (
            <Button
              id="navigate-to-button"
              classNames={[styles.editButton, 'gap-8']}
              iconSrc={CommonIcons.editIcon}
              text="Navigate to section"
              onClick={onNavigateClick}
              backgroundColor="transparent"
              borderColor="transparent"
              textColor={ColorsNew.darkGreen}
            />
          )}
        </div>
      )}
    </div>
  );
};

Accordion.propTypes = {
  title: PropTypes.string,
  instructions: PropTypes.string,
  content: PropTypes.element,
  classNames: PropTypes.arrayOf(PropTypes.string),
  isDefaultExpanded: PropTypes.bool,
  onNavigateClick: PropTypes.func,
};

export default Accordion;
